import React, { useLayoutEffect } from 'react';
// Layout
import DeskTop from './Pages/DeskTop';
import LoginPage from './LoginPage';
import Menu from './Pages/Menu';
// import ProtectedRoute from './ProtectedRoute';
// import ProtectedRoute from './AuthContext';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from './AuthContext';
import './styles/global-theme.css';

// Merchant
import MerchantList from './Pages/Merchant/merchantList';
import AddMerchant from './Pages/Merchant/addMerchant';
import UpdateMerchant from './Pages/Merchant/updateMerchant';
// Campaign
import Campaign from './Pages/Campaign/campaign';
import UpdateCampaign from './Pages/Campaign/updatecompaign';
import AddCampaign from './Pages/Campaign/addcampagin';
import ShowCampaign from './Pages/Campaign/showCampaign';
import Sendcampaign from './Pages/Campaign/sendampaign';
import AddImageInCampagin from './Pages/Campaign/addImageInCampagin';
import UpdateCampaignImage from './Pages/Campaign/updateCampaignImage';

// Catelog
import CatelogList from './Pages/Catelog/catelogList';
import AddCatelog from './Pages/Catelog/addCatelog';
import UpdateCatelog from './Pages/Catelog/upadteCatelog';
import ShowCatelog from './Pages/Catelog/showCatelog';
import CatelogPreview from './Pages/Catelog/catelogPreview';
import AddCatelogImage from './Pages/Catelog/addCatelogImage';
import SendCatelog from './Pages/Catelog/sendCatelog';
import ShowImagePreview from './Pages/Catelog/showImagePreview';

import ConnectedDevicesPage from './Pages/ConnectedDevise';
import DisConnectedDevicesPage from './Pages/DisConnected Devices';
import SendRowJson from './Pages/sendRowJson';
import SendJsonPackage from './Pages/sendJsonPackage';

// Audio
import AddAudio from './Pages/Audio/addAudio';
import Audio from './Pages/Audio/audio';
import UpdateAudio from './Pages/Audio/updateAudio';
import Sendaudio from './Pages/Audio/sendaudio';
import PublishAudio from './Pages/Audio/PublishAudio';

//Audio Package
import AudioPackage from './Pages/Audio Package/audioPackage'
import AddAudioPackage from './Pages/Audio Package/addAudioPackage'
import UpdateAudioPackage from './Pages/Audio Package/updateAudioPackage'
import SendAudioPackage from './Pages/Audio Package/sendaudioPackage'
import AudioListPackage from './Pages/Audio Package/audioListPackage';
import PublishAudioPackage from './Pages/Audio Package/PublishAudio';
import AddAudioListPackage from './Pages/Audio Package/addAudioListPackage';
import UpdateAudioListPackage from './Pages/Audio Package/updateAudioListPachage';

// Dqr Images
import DqrImagesList from './Pages/DqrImages/dqrImagesList';
import AddDqr from './Pages/DqrImages/addDqr';
import UpdateDqr from './Pages/DqrImages/updateDqr';
import ShowDqrImages from './Pages/DqrImages/showDqrImages';
import AddImagesInDqr from './Pages/DqrImages/addImagesInDqr';
import AddCategaroyDqr from './Pages/DqrImages/addCategaroyDqr';
import Publish7InchDQRImages from './Pages/DqrImages/Publish7InchDQRImage';
import DQRImagesPreview from './Pages/DqrImages/CatelogImagesPreview';
// import PreviewDqr from './Pages/DqrImages/previewDqr';
import PreviewDqr from './Pages/DqrImages/previewImages';
import UpdateDqrImage from './Pages/DqrImages/updateDqrImage';
import SendDqrImage from './Pages/DqrImages/sendDqrImage';
import PublishDQRImages from './Pages/DqrImages/PublishDQRImages';

import Firmware from './Pages/Firmware/firmware';
import SendFirmware from './Pages/Firmware/sendFirmware';
import PublishFirmware from './Pages/Firmware/PubliseFirmware';
import AddFirmware from './Pages/Firmware/addFirmware';
import UpdateFirmware from './Pages/Firmware/upadteFrrmware';

// MQTT Setting
import MQTTSetting from './Pages/MQTT Setting/mqttSetting';
import AddMqttSetting from './Pages/MQTT Setting/addMqttSettingn'
import UpdateMqttSetting from './Pages/MQTT Setting/updateMqttSetting';
// import ShowMqttSetting from './Pages/MQTT Setting/showCampaign'
import PublishMQTTSetting from './Pages/MQTT Setting/publishMqttSetting'
import SendMQTTSetting from './Pages/MQTT Setting/sendMqttSetting';


// Serialno
import SerialnoMQTTSetting from './Pages/SerialnoMQTTSetting/serialnoMqttSetting';
import AddSerialnoMqttSetting from './Pages/SerialnoMQTTSetting/addSerialnoMqttSettingn';
import UpdateSerialnoMqttSetting from './Pages/SerialnoMQTTSetting/updateSerialnoMqttSetting';
import ShowSerialnoMqttSetting from './Pages/SerialnoMQTTSetting/showSerialnoMqttSetting';
import PublishSerialnoMqttSetting from './Pages/SerialnoMQTTSetting/publishSerialnoMqttSetting';
import SendSerialnoMqttSetting from './Pages/SerialnoMQTTSetting/sendSerialnoMqttSetting';


//AWSIOTCoreSetting
import AWSIOTCoreList from './Pages/AWSIOTCoreSetting/AWSIOTCoreList';
import AddAWSIOTCore from './Pages/AWSIOTCoreSetting/addAWSIOTCoreSetting';
import SendAWSIOTCore from './Pages/AWSIOTCoreSetting/sendAWSIOTCoreSetting';
import publisAWSIOTCoreSetting from './Pages/AWSIOTCoreSetting/publisAWSIOTCoreSettting';

//HtmlDoc
import HtmlDocList from './Pages/HtmlDoc/htmlDocList';
import AddHtmlDoc from './Pages/HtmlDoc/addHtmlDoc';
import UpdateHtmlDoc from './Pages/HtmlDoc/updateHtmlDoc';
import ShowHtmlDoc from './Pages/HtmlDoc/showHtmlDoc';
import SendHtmlDoc from './Pages/HtmlDoc/sendHtmlDoc';
import PublishHtmlDoc from './Pages/HtmlDoc/publishHtmlDoc';
import AddHtmlDocFile from './Pages/HtmlDoc/addHtmlDocFile';
import UpdateHtmlDocFile from './Pages/HtmlDoc/updateHtmlDocFile';


//SubGroup
// import SubGroup from './Pages/SubGroup/Group';
// import AddSubGroup from './Pages/SubGroup/addGroup';
// import UpdateSubGroup from './Pages/SubGroup/updateGroup';
import Group from './Pages/SubGroup/Group';
import AddGroup from './Pages/SubGroup/addGroup';
import UpdateGroup from './Pages/SubGroup/updateGroup';
import SubGroup from './Pages/SubGroup/subGroup';
import AddSubGroup from './Pages/SubGroup/addSubGroup';
import UpdateSubGroup from './Pages/SubGroup/updateSubGroup';
import SubGroupData from './Pages/SubGroup/subGroupData';
import SubGroupDataList from './Pages/SubGroup/subGroupDataList';
import SubGroupDataAdd from './Pages/SubGroup/subGroupdatatAdd';

//History
import History from './Pages/History/history';

//Client Page
import ClientsPage from './Pages/clientPage/clientpage';
import Send from './Pages/send/send';
import LoginForClient from './Pages/login/login';


//MessageQueue
import MessageQueueList from './Pages/MessageQueue/MessageQueueList';


import UploadFileList from './Pages/UploadFile/uploadFileList';
import ApiDoc from './Pages/ApiDoc/apiDoc';

//HtmlDocZip
import HtmlDocZipList from './Pages/HtmlDocZip/htmlDocZipList'
import AddHtmlDocZip from './Pages/HtmlDocZip/addHtmlDocZip';
import SendHtmlDocZip from './Pages/HtmlDocZip/sendHtmlDocZip';
import UpdateHtmlDocZip from './Pages/HtmlDocZip/updateHtmlDocZip';

// Api Key Operation
import ApiKeyOperationList from './Pages/ApiKeyOperation/ApiKeyOperationList';
import AddApiKeyOperation from './Pages/ApiKeyOperation/addApiKeyOperation';
import UpdateApiKeyOperation from './Pages/ApiKeyOperation/updateApiKeyOperation';

import DefaultTemplate from './Pages/Default template/DefaultTemplate';
import AddTemplate from './Pages/Default template/AddTemplate';
import UpdateTemplate from './Pages/Default template/updateTemplate';


//Schedule
import ScheduleList from './Pages/Schedule/scheduleList';
import AddSchedule from './Pages/Schedule/addSchedule';
import UpdateSchedule from './Pages/Schedule/updateSchedule';
import ShowSchedule from './Pages/Schedule/showSchedule';
import AddSchedulerInfo from './Pages/Schedule/addSchedulerInfo';
import UpdateSchedulerInfo from './Pages/Schedule/updateSchedulerInfo';
import SendSchedule from './Pages/Schedule/sendSchedule';

import CatalogDashboard from './Pages/CatalogDashboard/catalogDashboard';
import CatalogStatistics from './Pages/CatalogDashboard/CatalogStatistics';

import POSDashboard from './Pages/POSDashboard/posDashboard';
import POSStatistics from './Pages/POSDashboard/posStatistics';
import SelectOption from './Pages/SelectOption';
import ThirdPartyReport from './Pages/ThirdPartyReport';
import RetailPulseReport from './Pages/RetailPulseReport';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/select-option" element={<ProtectedRoute element={SelectOption} />} />
          <Route path="/third-party-report" element={<ProtectedRoute element={ThirdPartyReport} />} />
          <Route path="/retail-pulse-report" element={<ProtectedRoute element={RetailPulseReport} />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/" element={<ProtectedRoute element={DeskTop} />} />


          {/* <Route path="/" element={<ProtectedRoute element={DeskTop} />} /> */}
          <Route path="/Connected-device" element={<ProtectedRoute element={ConnectedDevicesPage} />} />
          <Route path="/Disconnected-device" element={<ProtectedRoute element={DisConnectedDevicesPage} />} />
          <Route path="/Send-Row-Json" element={<ProtectedRoute element={SendRowJson} />} />
          <Route path="/Send-json-Package" element={<ProtectedRoute element={SendJsonPackage} />} />
          {/* Merchant */}
          <Route path="/merchantList" element={<ProtectedRoute element={MerchantList} />} />
          <Route path="/addmerchant" element={<ProtectedRoute element={AddMerchant} />} />
          <Route path="/updatemerchant/:id" element={<ProtectedRoute element={UpdateMerchant} />} />
          {/* Campaign */}
          <Route path="/compaign" element={<ProtectedRoute element={Campaign} />} />
          <Route path="/updatecampaign/:id" element={<ProtectedRoute element={UpdateCampaign} />} />
          <Route path="/updateimageinfo/:id/:id2/:name" element={<ProtectedRoute element={UpdateCampaignImage} />} />
          <Route path="/addcampaign" element={<ProtectedRoute element={AddCampaign} />} />
          <Route path="/showcampaign/:id/:name" element={<ProtectedRoute element={ShowCampaign} />} />
          <Route path="/addImageincampagin/:id/:name" element={<ProtectedRoute element={AddImageInCampagin} />} />
          <Route path="/sendcompaign" element={<ProtectedRoute element={Sendcampaign} />} />
          {/* <Route path="/CS80/campaign/:id" element={<ProtectedRoute element={PublishCampaign} />} /> */}


          <Route path="/sendcompaign/:merchant/:pos" element={<ProtectedRoute element={Sendcampaign} />} />

          {/* Catelog */}
          <Route path="/catelog" element={<ProtectedRoute element={CatelogList} />} />
          <Route path="/addcatelog" element={<ProtectedRoute element={AddCatelog} />} />
          <Route path="/updatecatelog/:id" element={<ProtectedRoute element={UpdateCatelog} />} />
          <Route path="/showcatelog/:id" element={<ProtectedRoute element={ShowCatelog} />} />
          <Route path="/catelogpreview/:id" element={<ProtectedRoute element={CatelogPreview} />} />
          <Route path="/catelogpreview-publish/:id" element={<CatelogPreview />} />
          <Route path="/add-catelog-image/:id" element={<ProtectedRoute element={AddCatelogImage} />} />
          <Route path="/send-catelog" element={<ProtectedRoute element={SendCatelog} />} />
          <Route path="/send-catelog/:merchant/:pos" element={<ProtectedRoute element={SendCatelog} />} />
          <Route path="/show-image-preview/:id" element={<ProtectedRoute element={ShowImagePreview} />} />

          {/* Audio */}
          <Route path="/audio" element={<ProtectedRoute element={Audio} />} />
          <Route path="/updateaudio/:id" element={<ProtectedRoute element={UpdateAudio} />} />
          <Route path="/addaudio" element={<ProtectedRoute element={AddAudio} />} />
          <Route path="/sendaudio" element={<ProtectedRoute element={Sendaudio} />} />
          <Route path="/sendaudio/:merchant/:pos" element={<ProtectedRoute element={Sendaudio} />} />
          {/* <Route path="/CS80/Audio/:id" element={<ProtectedRoute element={PublishAudio} />} /> */}
          {/* Audio Package */}
          <Route path="/audioPackage" element={<ProtectedRoute element={AudioPackage} />} />
          <Route path="/updateaudioPackage/:id" element={<ProtectedRoute element={UpdateAudioPackage} />} />
          <Route path="/addaudioPackage" element={<ProtectedRoute element={AddAudioPackage} />} />
          <Route path="/sendaudioPackage" element={<ProtectedRoute element={SendAudioPackage} />} />
          <Route path="/sendaudioPackage/:merchant/:pos" element={<ProtectedRoute element={SendAudioPackage} />} />
          <Route path="/audioListPackage/:id" element={<ProtectedRoute element={AudioListPackage} />} />
          {/* <Route path="/CS80/AudioPackage/:id" element={<ProtectedRoute element={PublishAudioPackage} />} /> */}
          <Route path="/addaudioListPackage/:id" element={<ProtectedRoute element={AddAudioListPackage} />} />
          <Route path="/updateAudioListPackage/:id/:id2" element={<ProtectedRoute element={UpdateAudioListPackage} />} />

          {/* DQR */}
          <Route path="/dqr-image-list" element={<ProtectedRoute element={DqrImagesList} />} />
          <Route path="/dqr-image-add" element={<ProtectedRoute element={AddDqr} />} />
          <Route path="/dqr-image-update/:id" element={<ProtectedRoute element={UpdateDqr} />} />
          <Route path="/show-dqr-images/:id/:name" element={<ProtectedRoute element={ShowDqrImages} />} />
          <Route path="/add-image-in-dqr" element={<ProtectedRoute element={AddImagesInDqr} />} />
          <Route path="/add-categaroy-in-dqr" element={<ProtectedRoute element={AddCategaroyDqr} />} />
          <Route path="/preview-images/:id/:id2" element={<ProtectedRoute element={PreviewDqr} />} />
          <Route path="/update-dqr-image/:id/:id2" element={<ProtectedRoute element={UpdateDqrImage} />} />
          <Route path="/dqr-images-preview/:id" element={<ProtectedRoute element={DQRImagesPreview} />} />
          <Route path="/send-Dqr-image" element={<ProtectedRoute element={SendDqrImage} />} />

          {/* Firmware  */}
          <Route path="/firmware" element={<ProtectedRoute element={Firmware} />} />
          <Route path="/send-firmware" element={<ProtectedRoute element={SendFirmware} />} />
          <Route path="/send-firmware/:merchant/:pos" element={<ProtectedRoute element={SendFirmware} />} />
          {/* <Route path="/CS80/firmware/:id" element={<ProtectedRoute element={PublishFirmware} />} /> */}
          <Route path="/add-Firmware" element={<ProtectedRoute element={AddFirmware} />} />
          <Route path="/update-Firmware/:id" element={<ProtectedRoute element={UpdateFirmware} />} />

          {/* MQTT Setting */}
          <Route path="/mqttSetting" element={<ProtectedRoute element={MQTTSetting} />} />
          <Route path="/addMqttSetting" element={<ProtectedRoute element={AddMqttSetting} />} />
          <Route path="/updateMqttSetting/:id" element={<ProtectedRoute element={UpdateMqttSetting} />} />
          {/* <Route path="/showMqttSetting/:id" element={<ProtectedRoute element={ShowMqttSetting} />} /> */}
          {/* <Route path="/CS80/:settingtype/:id" element={<ProtectedRoute element={PublishMQTTSetting} />} /> */}
          <Route path="/sendMQTTSetting" element={<ProtectedRoute element={SendMQTTSetting} />} />
          <Route path="/sendMQTTSetting/:merchant/:pos" element={<ProtectedRoute element={SendMQTTSetting} />} />

          {/* Serialno */}
          <Route path="/serialnoMqttSetting" element={<ProtectedRoute element={SerialnoMQTTSetting} />} />
          <Route path="/addSerialnoMqttSetting" element={<ProtectedRoute element={AddSerialnoMqttSetting} />} />
          <Route path="/updateSerialnoMqttSetting/:id/:deviceId" element={<ProtectedRoute element={UpdateSerialnoMqttSetting} />} />
          <Route path="/showSerialnoMqttSetting/:id" element={<ProtectedRoute element={ShowSerialnoMqttSetting} />} />
          <Route path="/CS80/SerialnoMqttSetting/:key/:id" element={<ProtectedRoute element={PublishSerialnoMqttSetting} />} />
          <Route path="/sendSerialnoMqttSetting" element={<ProtectedRoute element={SendSerialnoMqttSetting} />} />
          <Route path="/sendSerialnoMqttSetting/:merchant/:pos" element={<ProtectedRoute element={SendSerialnoMqttSetting} />} />

          {/* AWSIOTCore */}
          <Route path='/AWSIOTCoreList' element={<ProtectedRoute element={AWSIOTCoreList} />} />
          <Route path='/AddAWSIOTCore' element={<ProtectedRoute element={AddAWSIOTCore} />} />
          <Route path='/sendAWSIOTCore' element={<ProtectedRoute element={SendAWSIOTCore} />} />
          <Route path='/TOPWise_aws/:key' element={<ProtectedRoute element={publisAWSIOTCoreSetting} />} />


          {/* HtmlDoc */}
          <Route path='/htmldoclist' element={<ProtectedRoute element={HtmlDocList} />} />
          <Route path='/addhtmldoc' element={<ProtectedRoute element={AddHtmlDoc} />} />
          <Route path='/updatehtmldoc/:id' element={<ProtectedRoute element={UpdateHtmlDoc} />} />
          <Route path='/showhtmldoc/:id/:name' element={<ProtectedRoute element={ShowHtmlDoc} />} />
          <Route path='/addhtmlDocFile/:id/:name' element={<ProtectedRoute element={AddHtmlDocFile} />} />
          <Route path='/updatehtmlDocFile/:id/:id2/:name' element={<ProtectedRoute element={UpdateHtmlDocFile} />} />
          <Route path='/sendhtmldoc' element={<ProtectedRoute element={SendHtmlDoc} />} />
          <Route path='/SMD/htmldoc/:id' element={<PublishHtmlDoc />} />


          {/* HtmlDocZip */}
          <Route path='/htmldocziplist' element={<ProtectedRoute element={HtmlDocZipList} />} />
          <Route path='/addhtmldoczip' element={<ProtectedRoute element={AddHtmlDocZip} />} />
          <Route path='/sendhtmldoczip' element={<ProtectedRoute element={SendHtmlDocZip} />} />
          <Route path='/updatehtmldoczip/:id' element={<ProtectedRoute element={UpdateHtmlDocZip} />} />

          {/* MessageQueue */}
          <Route path='/messageQueueList' element={<ProtectedRoute element={MessageQueueList} />} />

          <Route path='/group' element={<ProtectedRoute element={Group} />} />
          <Route path='/addgroup' element={<ProtectedRoute element={AddGroup} />} />
          <Route path='/updategroup/:id' element={<ProtectedRoute element={UpdateGroup} />} />
          <Route path='/subgroup/:id' element={<ProtectedRoute element={SubGroup} />} />
          <Route path='/addsubgroup/:id' element={<ProtectedRoute element={AddSubGroup} />} />
          <Route path='/updatesubgroup/:id' element={<ProtectedRoute element={UpdateSubGroup} />} />
          <Route path='/subgroupdata/:subgroupId/:groupId' element={<ProtectedRoute element={SubGroupData} />} />
          <Route path='/subgroupdatalist/:subgroupId/:groupId' element={<ProtectedRoute element={SubGroupDataList} />} />
          <Route path='/subgroupdataadd/:subgroupId/:groupId' element={<ProtectedRoute element={SubGroupDataAdd} />} />

          {/* History */}
          <Route path='/history' element={<ProtectedRoute element={History} />} />


          {/* Client Page */}
          <Route path='/Client-page' element={<ProtectedRoute element={ClientsPage} />} />
          <Route path='/send' element={<ProtectedRoute element={Send} />} />
          <Route path='/Login-for-client' element={<ProtectedRoute element={LoginForClient} />} />

          <Route path='/upload-file-list' element={<ProtectedRoute element={UploadFileList} />} />
          <Route path='/api-doc' element={<ProtectedRoute element={ApiDoc} />} />
          {/* Api Key Operation */}
          <Route path='/api-key-operation-list' element={<ProtectedRoute element={ApiKeyOperationList} />} />
          <Route path='/addapikeyoperation' element={<ProtectedRoute element={AddApiKeyOperation} />} />
          <Route path='/updateapikeyoperation/:id' element={<ProtectedRoute element={UpdateApiKeyOperation} />} />

          <Route path='/default-template' element={<ProtectedRoute element={DefaultTemplate} />} />
          <Route path='/add-Template' element={<ProtectedRoute element={AddTemplate} />} />
          <Route path='/update-Template/:id' element={<ProtectedRoute element={UpdateTemplate} />} />
       
                    {/* Schedule */}
          <Route path='/schedulelist' element={<ProtectedRoute element={ScheduleList} />} />
          <Route path='/addschedule' element={<ProtectedRoute element={AddSchedule} />} />
          <Route path='/updateschedule/:id' element={<ProtectedRoute element={UpdateSchedule} />} />
          <Route path='/showschedule/:id/:name' element={<ProtectedRoute element={ShowSchedule} />} />
          <Route path='/addschedulerinfo/:id' element={<ProtectedRoute element={AddSchedulerInfo} />} />
          <Route path='/updateschedulerinfo/:id/:recordId' element={<ProtectedRoute element={UpdateSchedulerInfo} />} />
          <Route path='/sendSchedule' element={<ProtectedRoute element={SendSchedule} />} />

         <Route path="/catalog-dashboard" element={<ProtectedRoute element={CatalogDashboard} />} />
          <Route path="/catalog-statistics" element={<ProtectedRoute element={CatalogStatistics} />} />
          <Route path="/pos-dashboard" element={<ProtectedRoute element={POSDashboard} />} />
          <Route path="/pos-statistics" element={<ProtectedRoute element={POSStatistics} />} />
          

        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;